import { Drawer, Table, Tag, Icon, Tooltip } from "antd";
import moment from "moment";
import React from "react";
import { connect } from "react-redux";

let dateFormat = localStorage.getItem("company-details")
    ? JSON.parse(localStorage.getItem("company-details")).dateFormat
    : "DD.MM.YYYY";

class TrainingDetails extends React.Component {
    state = {
        visible: true,
        loading: false
    };

    onClose = () => {
        this.setState({ visible: false });
        setTimeout(() => {
            if (this.props.onClose) {
                this.props.onClose();
            }
        }, 300);
    };

    render() {
        let response = this.props.data || { total: 0, data: [] };
        let data = response.data || [];
        let total = response.total || 0;

        let drawerParam = this.props.drawerParam || {};
        let title = drawerParam.title || "Training Details";
        let icon = drawerParam.icon || <Icon type="profile" />;
        let bgColorClass = drawerParam.bgColorClass || "";

        const columns = [
            {
                title: "University",
                key: "universityName",
                render: function (_, record) {
                    return (
                        <div style={{ fontWeight: 600 }}>
                            {record.universityName ? record.universityName : "-"}
                        </div>
                    );
                }
            },
            {
                title: "Training Type",
                key: "trainingType",
                render: function (_, record) {
                    let type = record.trainingType ? record.trainingType : "N/A";
                    return (
                        <Tag color={type === "Virtual" ? "blue" : "green"}>
                            {type}
                        </Tag>
                    );
                }
            },
            {
                title: "Date & Time",
                key: "dateTime",
                render: function (_, record) {
                    let date = record.date
                        ? moment(record.date).format(dateFormat)
                        : "-";
                    let time = record.time ? record.time : "-";

                    return (
                        <div>
                            <Icon type="calendar" style={{ marginRight: 6 }} />
                            {date}
                            <br />
                            <Icon type="clock-circle" style={{ marginRight: 6 }} />
                            {time}
                        </div>
                    );
                }
            },
            {
                title: "Meeting Details",
                key: "meetingDetails",
                render: function (_, record) {
                    let trainingType = record.trainingType
                        ? record.trainingType
                        : "";

                    // VIRTUAL
                    if (trainingType === "Virtual") {
                        let meetingLink = record.meetingLink
                            ? record.meetingLink
                            : "";
                        let meetingId = record.meetingId
                            ? record.meetingId
                            : "-";
                        let meetingPassword = record.meetingPassword
                            ? record.meetingPassword
                            : "-";

                        return (
                            <div style={{ fontSize: "13px" }}>
                                <div>
                                    <Icon type="link" style={{ marginRight: 6 }} />
                                    {meetingLink ? (
                                        <a
                                            href={meetingLink}
                                            target="_blank"
                                            rel="noreferrer"
                                        >
                                            Join Meeting
                                        </a>
                                    ) : (
                                        "-"
                                    )}
                                </div>
                                <div style={{ marginTop: 4 }}>
                                    <strong>ID:</strong> {meetingId}
                                </div>
                                <div>
                                    <strong>Password:</strong> {meetingPassword}
                                </div>
                            </div>
                        );
                    }

                    // FACE TO FACE
                    let location = record.meetingLocation
                        ? record.meetingLocation
                        : "-";

                    return (
                        <div>
                            <Icon
                                type="environment"
                                style={{ marginRight: 6 }}
                            />
                            {location}
                        </div>
                    );
                }
            },
            {
                title: "Users",
                key: "users",
                render: function (_, record) {
                    let users = record.users ? record.users : [];

                    if (!users.length) {
                        return "-";
                    }

                    return (
                        <div>
                            {users.map(function (u, index) {
                                return (
                                    <Tag key={index} style={{ marginBottom: 4 }}>
                                        {u.name ? u.name : "Unknown"}
                                    </Tag>
                                );
                            })}
                        </div>
                    );
                }
            },
            {
                title: "Created By",
                key: "createdBy",
                align: "right",
                render: function (_, record) {
                    let creator = "System";
                    let time = "";

                    if (record.createdByUser) {
                        if (record.createdByUser.name) {
                            creator = record.createdByUser.name;
                        }
                        if (record.createdByUser.time) {
                            time = moment(
                                record.createdByUser.time
                            ).format(dateFormat + " HH:mm A");
                        }
                    }

                    return (
                        <div style={{ textAlign: "right" }}>
                            <div style={{ fontWeight: 600 }}>{creator}</div>
                            <div style={{ fontSize: "11px", color: "#999" }}>
                                {time}
                            </div>
                        </div>
                    );
                }
            }
        ];

        return (
            <Drawer
                title={
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            width: "98%"
                        }}
                    >
                        <span
                            style={{
                                display: "flex",
                                alignItems: "center"
                            }}
                        >
                            <span
                                style={{
                                    marginRight: 12,
                                    display: "flex",
                                    fontSize: "20px"
                                }}
                            >
                                {icon}
                            </span>
                            {title}
                        </span>
                        <Tag className="count-tag">{total} TOTAL</Tag>
                    </div>
                }
                placement="right"
                closable={true}
                onClose={this.onClose}
                visible={this.state.visible}
                width={1100}
                className={`dynamic-drawer ${bgColorClass}`}
            >
                <Table
                    dataSource={data}
                    columns={columns}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: 10,
                        pageSizeOptions: ["10", "20", "50"]
                    }}
                    loading={this.state.loading}
                    rowKey={function (record) {
                        return record._id;
                    }}
                />
            </Drawer>
        );
    }
}

export default connect(null, null)(TrainingDetails);
